import type { z } from "zod/v3";
import type { AIToolError } from "./ai-tool-error";
import type { ChainConfig } from "./chain";

export type BaseParams = {
  chainId: string;
};

/**
 * AIChainTool should be implemented by any tool that needs to be used with blockchain data
 */
export type AIChainTool<T extends BaseParams> = (chains: ChainConfig) => {
  description: string;
  inputSchema: z.ZodType<T>;
  execute: (params: T) => Promise<unknown | AIToolError>;
};

export const AVAILABLE_TOOLS = [
  "getTransactionsDetails",
  "retrieveTransactions",
  "getWalletState",
  "getTokenStates",
  "getEventLogs",
] as const;

export type AvailableTools = (typeof AVAILABLE_TOOLS)[number];

export const TOOL_FEATURE_MAP: Record<AvailableTools, string> = {
  getTransactionsDetails: "transactionSearch",
  retrieveTransactions: "transactionSearch",
  getWalletState: "walletInfo",
  getTokenStates: "tokenInfo",
  getEventLogs: "eventLogs",
};

export const AVAILABLE_TOOLS_ARRAY = [...AVAILABLE_TOOLS];
